import { Button, BUTTON_TYPE, BUTTON_SIZE } from '../../../../global/Button';
import { getNextButtonStyles } from '../../../../utils/tbbRegistration';
import batteryWarningImage from '../../../../images/battery_sticker.jpg';

import './PrintBatteryLabelButton.scss';

const PrintBatteryLabelButton = ({
  storeConfig,
}) => (
  <div className="PrintBatteryLabelButton">
    <Button
      type={BUTTON_TYPE.QUINARY}
      size={BUTTON_SIZE.LARGE}
      className="PrintBatteryLabelButton__button"
      onClick={() => window.open(batteryWarningImage, '_blank')}
      style={storeConfig && getNextButtonStyles(storeConfig)}
    >
      <img className="PrintBatteryLabelButton__button-image" src={batteryWarningImage} alt="Battery warning" />
      PRINT BATTERY LABEL*
    </Button>
    <div className="PrintBatteryLabelButton__message">
      *Battery label must be printed in color.
    </div>
  </div>
);

export default PrintBatteryLabelButton;
